import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from '@/vuex/store';
import VueMeta from 'vue-meta';

import VueLodash from 'vue-lodash';
import { cloneDeep, groupBy, chain, range } from 'lodash';
Vue.use(VueLodash, { name: 'custom', lodash: { cloneDeep, groupBy, chain, range } });

Vue.config.productionTip = false;
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import i18n from '@/i18n';
import { TranslatePlugin } from '@/plugins/translate';
import useValidation from '@/vee-validate';
import esens from '@/plugins/vuetify/themes/esens';
import zouk from '@/plugins/vuetify/themes/zoukwroclove';

useValidation();

const localVue = Vue;
localVue.use(Vuetify);
localVue.use(VueMeta);

const vuetify = new Vuetify({
    theme: {
        themes: {
            // light: esens.theme.themes.light,
            // dark: zouk.theme.themes.dark,
            light: zouk.theme.themes.light,
            dark: esens.theme.themes.dark,
        },
    },
});

Vue.use(TranslatePlugin);
new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App),
}).$mount('#app');

function getTranslation(key: string) {
    return i18n.t(key).toString();
}
